//ルックブック
// 画像リスト（サンプルとして一部の画像URLを使用）
const images = [
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb01.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb02.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb03.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb04.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb05.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb06.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb07.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb08.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb09.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb10.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb11.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb12.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb13.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb14.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb15.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb16.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb17.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb18.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb19.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb20.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb21.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb22.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb23.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb24.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb25.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb26.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb27.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb28.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb29.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb30.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb31.jpg',
  'https://cdn.shopify.com/s/files/1/0601/5238/1555/files/lb32.jpg',
];

// 初期表示画像数
const initialDisplayCount = 9;
// 1回の「もっと見る」で表示する画像数
const loadMoreCount = 9;

let currentIndex = 0;

// モーダル要素
const modal = document.getElementById('lookbook-imageModal');
const modalImg = document.getElementById('lookbook-modalImage');
const closeBtn = document.getElementsByClassName('lookbook-close')[0];

// ルックブックに画像を追加する関数
function loadImages(isInitialLoad = false) {
    const lookbook = document.getElementById('lookbook');
    const nextIndex = isInitialLoad
        ? Math.min(currentIndex + initialDisplayCount, images.length)
        : Math.min(currentIndex + loadMoreCount, images.length);
    
    for (let i = currentIndex; i < nextIndex; i++) {
        const img = document.createElement('img');
        img.src = images[i];
        img.classList.add('new-image');
        lookbook.appendChild(img);

        setTimeout(() => {
            img.classList.add('show');
        }, 100);

        // 画像クリック時にモーダルで表示
        img.addEventListener('click', function() {
            modal.style.display = 'block'; // モーダルを表示
            modalImg.src = this.src; // クリックされた画像のsrcをモーダルに設定
            document.body.style.overflow = 'hidden';
        });
    }

    currentIndex = nextIndex;

    if (currentIndex >= images.length) {
        document.getElementById('lookbook-more').style.display = 'none';
    } else {
        document.getElementById('lookbook-more').style.display = 'block';
    }
}

// 初期画像をロード
window.onload = function() {
    loadImages(true);
};

// 「もっと見る」ボタンのイベントリスナー
document.getElementById('lookbook-more').addEventListener('click', function() {
    loadImages();
});

// モーダルを閉じるためのイベントリスナー
closeBtn.addEventListener('click', function() {
    modal.style.display = 'none'; // モーダルを非表示
    document.body.style.overflow = 'initial';
});

// モーダル外をクリックした時に閉じる
window.addEventListener('click', function(event) {
    if (event.target === modal) {
        modal.style.display = 'none'; // モーダルを非表示
        document.body.style.overflow = 'initial';
    }
});